import React, { useCallback } from "react";
import PropTypes from "prop-types";
import FormField from "./FormField";
import "./FormDatetime.css";
import { DateTimePicker, TimePicker } from "@mui/x-date-pickers";
import { format } from "date-fns";
import { TextField } from "@mui/material";

function FormDatetime(props) {
  let convertDateTime = useCallback((date) => {
    let converted = "";

    if (date) {
      converted = format(date, props.outputFormat);
    }
    console.log(converted);
    return converted;
  });

  return (
    <FormField
      {...props}
      Field={DateTimePicker}
      fieldProps={({ value, onChange }) => {
        return {
          onChange: (e) => {
            onChange(convertDateTime(e));
          },
          value: value ? new Date(value) : props.initialValue ? new Date(props.initialValue) : "",

          slotProps: {
            field: { clearable: true, onClear: () => onChange(null) },
          },
          closeOnSelect: true,
          ...props.fieldProps,
          renderInput: (props) => {
            return <TextField {...props} style={{ width: "100%", backgroundColor: "rgba(100, 100, 100, 0.05)" }} />;
          },
          className: "FormDatetime",
        };
      }}
    />
  );
}

FormDatetime.propTypes = {
  name: PropTypes.string.isRequired, // FormField props
  tKey: PropTypes.string, // FormField props
  tDefault: PropTypes.string, // FormField props
  permissionKey: PropTypes.string, // FormField props
  gridSizes: PropTypes.object, // FormField props
  rules: PropTypes.object, // FormField props
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]), // FormField props

  textFieldType: PropTypes.string,
  timeFormat: PropTypes.string,
  dateFormat: PropTypes.string,
  outputFormat: PropTypes.string,
};

FormDatetime.defaultProps = {
  textFieldType: "text",
  timeFormat: "HH:mm",
  dateFormat: "dd-MM-yyyy",
  outputFormat: "yyyy-MM-dd HH:mm:00",
};

export default FormDatetime;
